import { render } from "./LoadingBar.vue?vue&type=template&id=4b946f7e"
import script from "./LoadingBar.vue?vue&type=script&lang=js"
export * from "./LoadingBar.vue?vue&type=script&lang=js"

import "./LoadingBar.vue?vue&type=style&index=0&id=4b946f7e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__